import type { ApprovalApi } from '@ipen-portal/plugin-approval-backend';
import type { SolutionContractingApi } from '@ipen-portal/plugin-solution-contracting-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const solutionContractingApiRef = createApiRef<
  TRPCOptionsProxy<SolutionContractingApi>
>().with({
  id: 'plugin.ipen.solution-contracting.api',
});

export const approvalApiRef = createApiRef<
  TRPCOptionsProxy<ApprovalApi>
>().with({
  id: 'plugin.ipen.approval.api',
});
